exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".container-386cd{margin:0 auto}.container-386cd .breadcrumbs-8e56f{margin-bottom:24px;font-size:14px;line-height:22px}.container-386cd .content-15d75{display:flex;justify-content:space-between;gap:24px}", ""]);

// Exports
exports.locals = {
	"container": "container-386cd",
	"breadcrumbs": "breadcrumbs-8e56f",
	"content": "content-15d75"
};